import { Rout_create } from './Rout.create'
import { Rout_replace, Rout_to } from './Rout'

export interface Rout_LocationRoutesArgs {
    LocationApp: React.FunctionComponent<unknown>
    Loca_OwnershipPage: React.FunctionComponent<unknown>
}

export const Rout_LocationRoutes = (args: Rout_LocationRoutesArgs) => [
    Rout_create('/locationOwnership/:locationId', args.Loca_OwnershipPage),
    Rout_create('/location/:id/timeline/report-end', args.LocationApp),
    Rout_create('/location/:id/timeline', args.LocationApp),
    Rout_create('/location/map', args.LocationApp),
    Rout_create('/location/detail', args.LocationApp),
    Rout_create('/location/addnote', args.LocationApp),
    Rout_create('/location/editinfo', args.LocationApp),
    Rout_create('/location/addLocation', args.LocationApp),
    Rout_create('/location', args.LocationApp),
]

export type Rout_LocationPage = 'select' | 'timeline' | 'detail' | 'map' | 'addnote' | 'editinfo' | 'addLocation'
export type Rout_LocationMode = 'normal' | 'report-end'

export function Rout_getLocationMode(route: { path: string }): Rout_LocationMode {
    if (route.path === '/location/:id/timeline/report-end') return 'report-end'
    return 'normal'
}

export function Rout_getLocationPage(route: { path: string }): Rout_LocationPage {
    if (route.path === '/location/:id/timeline/report-end') return 'timeline'
    if (route.path === '/location/:id/timeline') return 'timeline'
    if (route.path === '/location/map') return 'map'
    if (route.path === '/location/detail') return 'detail'
    if (route.path === '/location/addnote') return 'addnote'
    if (route.path === '/location/editinfo') return 'editinfo'
    if (route.path === '/location/addLocation') return 'addLocation'
    if (route.path === '/location') return 'select'
    return 'select'
}

export function Rout_toTimeline(locationId: number) {
    Rout_to(`/location/${locationId}/timeline`)
}

export function Rout_replaceWithTimeline(locationId: number) {
    Rout_replace(`/location/${locationId}/timeline`)
}

/**
 * Add 'report-end' to url so that we can change the back button behaviour on that page
 * TODO: Maybe use query parameter or find another solution. The main issue is that going
 * 'back' to a report that you've finished breaks everything at the moment.
 */
export function Rout_toTimelineReportEnd(locationId: number) {
    Rout_to(`/location/${locationId}/timeline/report-end`)
}

export function Rout_toTimelineWithoutId() {
    Rout_to(`/location/timeline`)
}

export function Rout_toTimelineDetail() {
    Rout_to(`/location/detail`)
}

export function Rout_toMap() {
    Rout_to(`/location/map`)
}

export function Rout_toLocationAddNote() {
    Rout_to(`/location/addnote`)
}

export function Rout_toLocationEditInfo() {
    Rout_to(`/location/editinfo`)
}

export function Rout_toAddLocation() {
    Rout_to(`/location/addLocation`)
}

export function Rout_toLocationSearch() {
    Rout_to(`/location`)
}

export function Rout_toLocationOwnership(locationId: number) {
    Rout_to(`/locationOwnership/${locationId}`)
}
